export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: 'faq-01',
    question: '在星辰影院观看需要注册或付费吗？',
    answer:
      '浏览片库与在线观看都无需注册账号。站点只聚合公开的影视信息与播放入口，你可以直接打开页面观看，省去反复注册的麻烦。',
  },
  {
    id: 'faq-02',
    question: '为什么同一部作品会有好几条播放线路？',
    answer:
      '为了让不同网络环境下的观众都能顺畅观看，我们会为同一作品保留多条备用线路。遇到卡顿时，切换一条线路通常就能恢复流畅。',
  },
  {
    id: 'faq-03',
    question: '画质为什么有时会自动变化？',
    answer:
      '播放器会根据当前网速自动调整清晰度，优先保证播放顺畅。网络良好时可以手动切到高清或超清，网速波动时又会自动回降，避免长时间缓冲。',
  },
  {
    id: 'faq-04',
    question: '内容多久更新一次？',
    answer:
      '热门剧集通常跟随更新节奏同步上新，新片则在作品上线后尽快整理。具体更新时间可以查看页面的“本周更新日历”，以站内公告为准。',
  },
  {
    id: 'faq-05',
    question: '收藏和观看进度保存在哪里？',
    answer:
      '由于无需登录，收藏与观看进度保存在你本机的浏览器中。清除浏览器数据后这些记录会消失，换设备观看不会自动同步。',
  },
  {
    id: 'faq-06',
    question: '遇到无法播放的情况怎么办？',
    answer:
      '可以先尝试刷新页面、切换播放线路，或更换浏览器与网络。如果问题持续存在，可能是该来源暂时不可用，我们会在核对后尽快更新可用线路。',
  },
];